<template lang="pug">
    header.header-bar.d-flex.justify-space-between.py-3.pl-6.pr-4
        div.d-flex.align-end
            //- v-img(src="@/assets/images/UPGPT.png" max-width="150" height="32" cover alt="Logo")
            span.pb-1(style="font-size:25px; font-weight: 600; color: #666; letter-spacing: 1px") {{$t('TENANTCENTER.TITLE')}}
        div(v-if='isTenantLoggedIn')
            v-btn(@click="switchLang('TW')" text elevation='0' :color="twlang ? '#444' : '#ccc'") 繁體
            v-btn(@click="switchLang('EN')" text elevation='0' :color="!twlang ? '#444' : '#ccc'") EN
            v-btn(@click="onlogout()" text elevation='0' color='#444') {{$t('TENANTCENTER.LOGOUT')}}
                v-icon.pl-1.pt-1(size='18' color='#444') mdi-logout-variant
</template>
<script>
import { mapActions } from 'vuex';
import i18n from '/common/plugins/vue-i18n.js';
export default {
    data() {
        return {
            isLogin: true,
            redirectTo:'/tenant_center/login',
            twlang: true,
        }
    },
    created(){
        let lang = window.localStorage.getItem('tenantcenter_language');
        if (lang == 'zh_TW') {
            this.twlang = true;
        }else{
            this.twlang = false;
        }
    },
    methods: {
        ...mapActions([
            'logoutTenantCenterUser',
        ]),
        async onlogout(){
            this.isLogin = false;
            await this.logoutTenantCenterUser()
                .then(() => {

                    this.$emit('logoutSuccess');
                    this.$router.push(this.redirectTo);
                    window.location.reload()
            })
        },
        switchLang(language){
            if(language == 'TW'){
                this.twlang = true;
                window.localStorage.setItem('tenantcenter_language', 'zh_TW');
                i18n.locale = 'zh_TW';
            }else{
                this.twlang = false;
                window.localStorage.setItem('tenantcenter_language', 'en_US');
                i18n.locale = 'en_US';
            }
            window.location.reload()
        }

    },
    computed: {
        isTenantLoggedIn(){
            return !!window.localStorage.getItem('tenantcenter_user');
        }
    },
    watch: {
 
    }
}
</script>